<template>
  <b-overlay :show="showOverlayConfiguration" rounded="sm">
    <b-container fluid="true">
      <!-- User Interface controls -->
      <b-row>
        <b-col lg="6" class="my-1">
          <b-form-group
            label="Sort"
            label-for="sort-by-select"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-input-group size="sm">
              <b-form-select
                id="sort-by-select"
                v-model="sortBy"
                :options="sortOptions"
                :aria-describedby="ariaDescribedby"
                class="w-75"
              >
                <template #first>
                  <option value="">-- none --</option>
                </template>
              </b-form-select>

              <b-form-select
                v-model="sortDesc"
                :disabled="!sortBy"
                :aria-describedby="ariaDescribedby"
                size="sm"
                class="w-25"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="6" class="my-1">
          <b-form-group
            label="Initial sort"
            label-for="initial-sort-select"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="initial-sort-select"
              v-model="sortDirection"
              :options="['asc', 'desc', 'last']"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="6" class="my-1">
          <b-form-group
            label="Filter"
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                @input="currentPage=1"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="6" class="my-1">
          <b-form-group
            v-model="sortDirection"
            label="Filter On"
            description="Leave all unchecked to filter on all data"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox-group
              v-model="filterOn"
              :aria-describedby="ariaDescribedby"
              class="mt-1"
            >
              <b-form-checkbox value="name">Name</b-form-checkbox>
              <b-form-checkbox value="location">location</b-form-checkbox>
              <b-form-checkbox value="haveImageProfile">Have Picture?</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>

        <b-col sm="5" md="6" class="my-1">
          <b-form-group
            label="Per page"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="7" md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="mt-4"
          >
            <template #first-text><span class="text-success">First</span></template>
            <template #prev-text><span class="text-danger">Prev</span></template>
            <template #next-text><span class="text-warning">Next</span></template>
            <template #last-text><span class="text-info">Last</span></template>
            <template #ellipsis-text>
              <b-spinner small type="grow"></b-spinner>
              <b-spinner small type="grow"></b-spinner>
              <b-spinner small type="grow"></b-spinner>
            </template>
            <template #page="{ page, active }">
              <b v-if="active">{{ page }}</b>
              <i v-else>{{ page }}</i>
            </template>
          </b-pagination>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <span>Total Result : {{ totalRows }} users</span><br>
      <b-spinner type="grow" label="Spinning"></b-spinner>
      <b-button variant="warning" @click="discardUsersFromSearch" v-if="selected.length>0" size="sm">
        <p>
          Discard {{ selected.length }} users from the search<br>

        </p>
      </b-button>
      <b-table
        ref="resultSearchTable"
        empty-text="Please wait while we pool the result of your search"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        select-mode="multi"
        stacked="true"
        responsive="true"
        selectable
        @row-selected="onRowSelected"
        show-empty
        small
        @filtered="onFiltered"
      >
        <template #cell(jobTitle)="row">
          <div class="text-wrap">{{ row.value }}</div>
        </template>
        <template #cell(location)="row">
          <div class="text-wrap">{{ row.value }}</div>
        </template>
        <template #cell(imageProfile)="row">
          <b-img rounded="circle" v-if="row.value!=='ghost'" v :src="row.value" alt="Profile" width="80" height="80"/>
          <b-img rounded="circle" v-else width="80" height="80"
                 src="https://html-templates-ses-yoursynchronicity.s3-eu-west-1.amazonaws.com/public-assets/anonymousprofile.png"
                 alt="Profile"/>
        </template>
        <template #cell(url)="row">
          <b-button :href="row.value" target="_blank" variant="primary">Go to profile</b-button>
        </template>

        <template #cell(actions)="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
          </b-button>
        </template>

        <template #row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
            </ul>
          </b-card>
        </template>

      </b-table>


    </b-container>
    <template v-slot:overlay>
      <div class="text-center">
        <p id="cancel-label">Please wait while we preview your search, this can take up to 2min.</p>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             style="margin: auto; background: none; display: block; shape-rendering: auto;"
             width="100px" height="100px" viewBox="0 0 100 100"
             preserveAspectRatio="xMidYMid">
          <path fill="none" stroke="#07abcc" stroke-width="3"
                stroke-dasharray="42.76482137044271 42.76482137044271"
                d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
                stroke-linecap="round" style="transform:scale(1);transform-origin:50px 50px">
            <animate attributeName="stroke-dashoffset" repeatCount="indefinite"
                     dur="1.408450704225352s" keyTimes="0;1"
                     values="0;256.58892822265625"></animate>
          </path>
          <!-- [ldio] generated by https://loading.io/ --></svg>
      </div>
    </template>
    <b-modal v-model="statusErrorResultSearch" centered id="modal-close-results"
             title="Please confirm" @ok="errorResultSearch"
             no-close-on-backdrop
             no-close-on-esc
             ok-only
             hide-header-close>
      <p class="my-4">We are sorry, something wrong has happened on our side, please contact the administrator for
        more details.</p>

    </b-modal>
    <b-modal id="modal-fix-pin" v-model="modalPin" @close="modalPin = false" title="Pin" @ok="submitPin"
             ok-title="Submit">
      <p class="my-2">
        Please enter the pin you just received in your email...
      </p>
      <b-form-input v-model="textPin" placeholder="Your Linkedin pin"></b-form-input>
      <b-spinner v-if="pinSent" type="grow" label="Spinning"></b-spinner>
      <b-badge v-if="wrongPin" variant="warning">Wrong pin,<br> please check that you have used the latest email from
        linkedin for the Pin.
      </b-badge>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  name: "ListUserInSearchResult",
  props: ['savedSearchId'],
  data() {
    return {
      modalPin: false,
      textPin: "",
      pinSent: false,
      wrongPin: false,
      showOverlayConfiguration: true,
      statusErrorResultSearch: false,
      counterErrorResultSearch: 0,
      items: [],
      fields: [
        {key: 'imageProfile', label: 'Picture', class: 'text-center'},
        {key: 'name', label: 'Person full name', sortable: true, sortDirection: 'desc'},
        {key: 'location', label: 'location', sortable: true, class: 'text-center'},
        {key: 'url', label: 'Linkedin url', class: 'text-center'},
        {key: 'jobTitle', label: 'Job title', sortable: true, class: 'text-center'},
        {
          key: 'haveImageProfile',
          label: 'have Image Profile',
          formatter: (value, key, item) => {
            return value !== "ghost" ? 'Yes' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },

      ],
      selected: [],
      discaredItems: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {text: f.label, value: f.key}
        })
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    errorResultSearch() {
      this.statusErrorResultSearch = false;
      this.$emit('event', 'fail')
    },
    onRowSelected(items) {
      this.selected = items
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    submitPin(bvModalEvt) {
      console.log("Pin submitted", this.textPin)
      bvModalEvt.preventDefault()
      this.pinSent = true;
      this.wrongPin = false;
      const path = this.BACKEND_YSY + "/linkedin/initPin";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      this.$http
        .post(path, {
          email_linkedin: this.$store.getters.getEmailLinkedin,
          ysy_username: this.$store.getters.getUser,
          pin: this.textPin,
        }, {headers})
    },
    getUpdateState() {
      console.log('Starting - get update state');
      this.state_polling = setInterval(async () => {
        this.logged = false;
        const path = this.BACKEND_YSY + "/linkedin/get-init-state";
        let headers = {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${localStorage.id_token}`
        };
        await this.$http
          .post(path, {
            email_linkedin: this.$store.getters.getEmailLinkedin,
            ysy_username: this.$store.getters.getUser,
          }, {headers})
          .then(async res => {
            console.log(res.data.statusCode);
            if (res.data.statusCode === 102 && this.pinSent === false) {
              console.log('waiting pin');
              this.wrongPin = false;
              this.modalPin = true;
            }
            if (res.data.statusCode === 403) {
              console.log('wrong pin');
              this.wrongPin = true;
              this.modalPin = true;
              this.pinSent = false;
            }
            if (res.data.statusCode === 200) {
              console.log('correct pin');
              clearInterval(this.state_polling);
              this.$bvModal.hide('modal-fix-pin')
              this.modalPin = false;
              this.wrongPin = false;
              this.textPin = "";
            }
          })
          .catch(async error => {
            // eslint-disable-next-line
            const self = this;
            if (error.response.status === 401) {
              console.error('Unauthorized', error.response.data);
              await this.refreshIdToken().then(function (result) {
                console.log("res promise", result); // "Stuff worked!"
                self.getUpdateState();
              }, function (err) {
                console.log("it broke", err); // Error: "It broke"
                self.$router.push({name: 'login'});
              });
            }
          });

      }, 3000)
    },
    getListUsersSearchResult() {
      const path = `${this.BACKEND_YSY}/linkedin/get-init-state`;
      console.log('this.savedSearchId', this.savedSearchId)
      this.$http
        .post(path, JSON.stringify({
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          saved_search_id: this.savedSearchId,
          listUsersSearch: 'true'

        }), {
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.id_token}`
          }
        })
        .then(res => {
          console.log(res);
          var self = this
          self.totalRows = 1
          self.items = []
          if (Object.keys(res.data).length > 0) {
            this.showOverlayConfiguration = false;
            this.counterErrorResultSearch = 0;
          }
          Object.entries(res.data).forEach(([page_key, page_value]) => {
            Object.entries(page_value).forEach(([user_key, user_value]) => {
              self.totalRows = self.totalRows + 1
              let tmp_dict_result = {
                page: page_key,
                isActive: false,
                jobTitle: user_value["entity_result_job_title"],
                imageProfile: user_value["entity_result_image"],
                url: user_value["entity_result_link_connection"],
                haveImageProfile: user_value["entity_result_image"],
                location: user_value["entity_result_location_title"],
                name: user_value["entity_result_full_name_title"],
              }

              if (!self.discaredItems.some(e => e.url === tmp_dict_result.url)) {
                self.items.push(tmp_dict_result)
              }
            })
          })
          this.listUserSearch = res.data
          this.$refs.resultSearchTable.refresh()
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);

        });
    },
    discardUsersFromSearch() {
      const path = `${this.BACKEND_YSY}/linkedin/initState`;

      this.discaredItems.push(...this.selected)
      console.log('this.discaredItems', this.discaredItems)

      this.$http
        .post(path, JSON.stringify({
          ysy_username: this.$store.getters.getUser,
          email_linkedin: this.$store.getters.getEmailLinkedin,
          saved_search_id: this.savedSearchId,
          list_to_discard: this.discaredItems,
          excludeUserFromSearch: 'true'

        }), {
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.id_token}`
          }
        })
        .then(res => {
          console.log(res);
          this.getListUsersSearchResult()
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);

        });
    },
    pollSearchResultData() {
      this.polling = setInterval(() => {
        this.getListUsersSearchResult()
        this.counterErrorResultSearch = this.counterErrorResultSearch + 1
        if (this.counterErrorResultSearch > 10) {
          console.log('Could not get the search result')
          this.statusErrorResultSearch = true;
        }
        console.log('Polling data in 9 secs')
      }, 1000 * 9)
    },
  },
  beforeDestroy() {
    clearInterval(this.polling)
    clearInterval(this.state_polling)
  },
  created() {
    this.getUpdateState()
    console.log('Start polling')
    this.getListUsersSearchResult()
    this.pollSearchResultData()
  }
}
</script>

<style scoped>

</style>
